import {observable, computed, action} from 'mobx';

class ConfirmationDialog {
  @observable message;
  @observable buttons = [];
  promise;
  resolve;
  reject;

  @computed get isActive() {
    return this.message !== undefined;
  }

  @action.bound confirm(message, buttons = [{label: "OK", value: "true", className: "button-ok"}, {label: "Cancel", value: false, className: "button-cancel"}]) {
    if(this.promise) {
      throw new Error('Dialog already active.')
    }
    this.message = message;
    this.buttons = buttons;
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    }).then(result => {
      this.message = undefined;
      this.buttons = [];
      this.promise = undefined;
      this.resolve = undefined;
      this.reject = undefined;
      return result;
    }).catch(error => {
      this.message = undefined;
      this.buttons = [];
      this.promise = undefined;
      this.resolve = undefined;
      this.reject = undefined;
      throw error;
    })
    return this.promise;
  }
}

export default new ConfirmationDialog();


// WEBPACK FOOTER //
// ./src/model/ConfirmationDialog.js